import type { ReactNode } from 'react';
import { ChevronDown } from 'lucide-react';

interface HeaderProps {
  title: string;
  subtitle?: ReactNode;
  /** Если задан — заголовок становится переключателем («заголовок сам — переключатель»). */
  onTitleClick?: () => void;
  titleExpanded?: boolean;
  /** Кнопки справа (.ibtn). */
  actions?: ReactNode;
  /** Выпадающее меню — рисуется внутри шапки, под заголовком. */
  menu?: ReactNode;
}

/** Шапка экрана: крупный заголовок 27/700, строка под ним, кнопки справа. */
export function Header({ title, subtitle, onTitleClick, titleExpanded, actions, menu }: HeaderProps) {
  const body = (
    <>
      <b>
        {title}
        {onTitleClick && <ChevronDown aria-hidden />}
      </b>
      {subtitle !== undefined && <span>{subtitle}</span>}
    </>
  );
  return (
    <header className="hdr">
      {onTitleClick ? (
        <button type="button" className="ttl" onClick={onTitleClick} aria-haspopup="menu" aria-expanded={!!titleExpanded}>
          {body}
        </button>
      ) : (
        <div className="ttl plain">{body}</div>
      )}
      {actions}
      {menu}
    </header>
  );
}
